import styles from "./styles/success-created-custom-modal.module.scss";
import StyledButton from "@/components/common/styled-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const SuccessCreatedCustomModal = () => {
  const { hideModal } = useGlobalModalContext();

  return (
    <div className={styles.wrapper}>
      <h2>Voice Cloning Started Successfully</h2>
      <h4>
        Please wait until the cloning process is complete. After that, enjoy your cloned voice!      
      </h4>
      <StyledButton title={"OK"} onClick={hideModal} />
    </div>
  );
};

export default SuccessCreatedCustomModal;
